import noUiSlider from 'nouislider';

function toggleFilters() {
  let button = $('.filters__current');
  let dropdown = $('.filters__dropdown');
  let items = $('.filters__dropdown p');
  let labels = $('.filters__labels'); // Получаем все блоки .filters__labels
  let tagsContainer = $('.filters__tags'); // Блок для добавления тегов
  let bg = $('.filters__bg');
  const clearButtonClass = 'filters__clear'; // Класс кнопки очистки
  const clearButtonHtml = `
    <button class="${clearButtonClass}">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.90729 14.3499C4.54831 14.3498 4.25726 14.6408 4.25722 14.9998C4.25717 15.3588 4.54815 15.6498 4.90714 15.6499L4.90729 14.3499ZM9.89691 15V15.65H9.89692L9.89691 15ZM9.89691 5.00011V5.65011H9.89692L9.89691 5.00011ZM3.54041 4.54035C3.28655 4.79418 3.28653 5.20573 3.54035 5.45959L7.67667 9.59642C7.9305 9.85028 8.34206 9.8503 8.59591 9.59648C8.84977 9.34265 8.84979 8.93109 8.59597 8.67724L4.91924 5.00006L8.59642 1.32333C8.85028 1.0695 8.8503 0.657944 8.59648 0.404087C8.34265 0.150231 7.93109 0.150206 7.67724 0.404031L3.54041 4.54035ZM5.81443 5.00011L5.81439 5.65011H5.81443V5.00011ZM5.81443 15L5.81435 15.65H5.81443V15ZM9.89692 15.65C11.7697 15.65 13.2244 14.9558 14.2056 13.8742C15.177 12.8035 15.65 11.3921 15.65 9.99997C15.65 8.60786 15.177 7.19644 14.2056 6.12578C13.2243 5.04416 11.7697 4.35008 9.8969 4.35011L9.89692 5.65011C11.4261 5.65009 12.5231 6.20595 13.2428 6.99928C13.9725 7.80358 14.35 8.89212 14.35 9.99997C14.35 11.1078 13.9725 12.1964 13.2428 13.0007C12.5231 13.7941 11.4261 14.35 9.8969 14.35L9.89692 15.65ZM9.89691 4.35011H5.81443V5.65011H9.89691V4.35011ZM5.81447 4.35011L4.00004 4.35L3.99996 5.65L5.81439 5.65011L5.81447 4.35011ZM4.90714 15.6499L5.81435 15.65L5.81451 14.35L4.90729 14.3499L4.90714 15.6499ZM5.81443 15.65H9.89691V14.35H5.81443V15.65Z" fill="#817F87"/>
      </svg>
      <span>Сбросить фильтр</span>
    </button>`; // Шаблон кнопки очистки

  button.on('click', function() {
    button.not(this).next().removeClass('active');
    button.not(this).removeClass('active');
    $(this).toggleClass('active');
    bg.addClass('active');
    $(this).next().toggleClass('active');
  });

  items.on('click', function() {
    $(this).prevAll().removeClass('active');
    $(this).nextAll().removeClass('active');
    $(this).addClass('active');
    $(this).parent().prev().children('input').val($(this).text());
    $(this).parent().prev().children('p').text($(this).text());
    $(this).parent().removeClass('active');
    $(this).parent().prev().removeClass('active');
    bg.removeClass('active');
  });

  let checkedItemsByLabel = {}; // Объект для хранения массивов для каждого блока

  labels.each(function(index) {
    let label = $(this);
    checkedItemsByLabel[index] = []; // Создаем массив для каждого блока

    label.on('click', '.filters__label', function() {
      let input = $(this).children('input');
      let checkedItem = input.val();
      let currentFilter = $(this).closest('.filters__item'); // Текущий блок фильтра

      if (input.is(':checked')) {
        // Добавляем значение в массив и создаем тег, если чекбокс выбран
        if (checkedItem && !checkedItemsByLabel[index].includes(checkedItem)) {
          checkedItemsByLabel[index].push(checkedItem);
          addTag(checkedItem, index, input, currentFilter);
          updateFilterText(index, currentFilter);
        }
      } else {
        // Удаляем значение из массива и тег, если чекбокс снят
        removeTag(checkedItem, index, input, currentFilter);
        updateFilterText(index, currentFilter);
      }

      updateClearButtonState(); // Проверяем состояние кнопки "Очистить"

    });
  });

  // Функция для добавления тега
  function addTag(text, labelIndex, input, currentFilter) {
    // Проверяем, есть ли уже тег с таким значением, чтобы не дублировать
    if ($(`.filters__tag[data-value="${text}"][data-label-index="${labelIndex}"]`).length === 0) {
      let tagHtml = `
        <div class="filters__tag" data-value="${text}" data-label-index="${labelIndex}">
          <span>${text}</span>
          <div class="filters__remove">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 5L10 11M10 5L4 11" stroke="#817F87" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>`;
      
      // Добавляем тег в блок .filters__tags
      tagsContainer.append(tagHtml);

      // Обработчик для удаления тега по клику
      tagsContainer.find('.filters__remove').last().on('click', function() {
        removeTag(text, labelIndex, input, currentFilter);
        updateFilterText(labelIndex, currentFilter);
        updateClearButtonState(); // Проверяем состояние кнопки "Очистить" после удаления тега
      });
    }
  }

  // Функция для удаления тега и обновления состояния
  function removeTag(text, labelIndex, input, currentFilter) {
    // Удаляем тег из DOM
    $(`.filters__tag[data-value="${text}"][data-label-index="${labelIndex}"]`).remove();

    // Удаляем значение из массива
    let itemIndex = checkedItemsByLabel[labelIndex].indexOf(text);
    if (itemIndex > -1) {
      checkedItemsByLabel[labelIndex].splice(itemIndex, 1);
    }

    // Снимаем чекбокс
    input.prop('checked', false);

    console.log(`Updated checked items for label ${labelIndex}:`, checkedItemsByLabel[labelIndex]);
  }

  // Функция для обновления текста в блоке p(data-default) в зависимости от выбранных значений
  function updateFilterText(labelIndex, currentFilter) {
    let filterTextElement = currentFilter.find('.filters__current p');
    let defaultText = filterTextElement.data('default');


    // Обновляем текст в <p> элементе
    if (checkedItemsByLabel[labelIndex].length > 0) {
      $('.filters__trigger span').show();
      $('.filters__trigger span').text(checkedItemsByLabel[labelIndex].length);
      filterTextElement.text(checkedItemsByLabel[labelIndex].join(', '));
    } else {
      filterTextElement.text(defaultText);
      $('.filters__trigger span').text('');
      $('.filters__trigger span').hide();
    }
  }

  // Функция для обновления состояния кнопки очистки
  function updateClearButtonState() {
    // Проверяем, есть ли выбранные элементы в любом из массивов
    let hasCheckedItems = Object.values(checkedItemsByLabel).some(array => array.length > 0);

    if (hasCheckedItems) {
      tagsContainer.addClass('active');
      // Если есть выбранные элементы, добавляем кнопку очистки, если ее нет
      if ($(`.${clearButtonClass}`).length === 0) {
        tagsContainer.append(clearButtonHtml); // Генерируем кнопку внутри .filters__tags
        // Добавляем обработчик на вновь созданную кнопку
        $(`.${clearButtonClass}`).on('click', function() {
          clearAllFilters();
        });
      }
    } else {
      tagsContainer.removeClass('active');
      // Если нет выбранных элементов, удаляем кнопку
      $(`.${clearButtonClass}`).remove();
    }
  }

  // Функция для очистки всех фильтров
  function clearAllFilters() {
    // Снять все чекбоксы
    labels.find('input[type="checkbox"]').prop('checked', false);

    // Очистить массивы checkedItemsByLabel
    for (let index in checkedItemsByLabel) {
      checkedItemsByLabel[index] = [];
    }

    // Удалить все теги
    tagsContainer.empty();

    // Вернуть тексты по умолчанию
    labels.each(function(index) {
      let currentFilter = $(this).closest('.filters__item');
      updateFilterText(index, currentFilter);
    });

    // Обновляем состояние кнопки очистки
    updateClearButtonState();

    console.log("All filters have been cleared.");
  }

  $(document).mouseup(function(e) {
    if (!dropdown.is(e.target) && !button.is(e.target) && dropdown.has(e.target).length === 0) {
      dropdown.removeClass('active');
      button.removeClass('active');
      bg.removeClass('active');
    }
  });

  $('.filters__close').on('click', function() {
    dropdown.removeClass('active');
    button.removeClass('active');
    bg.removeClass('active');
    $('.filters__items').removeClass('active');
    $('.filters__apply').hide();
  });

  $('.filters__trigger').on('click', function() {
    bg.addClass('active');
    $('.filters__items').addClass('active');
    $('.filters__apply').show();
  });

  $('.filters__apply').on('click', function() {
    dropdown.removeClass('active');
    button.removeClass('active');
    bg.removeClass('active');
    $('.filters__items').removeClass('active');
    $('.filters__apply').hide();
  });

  $('.filters__title').on('click', function() {
    $(this).toggleClass('active');
    $(this).nextAll().toggle();
    $(this).nextAll().parent().toggleClass('no-padding');
  });

  document.addEventListener('keydown', function(e) {
    if (e.key == 'Escape') {
      button.removeClass('active');
      $('.filters__apply').hide();
      dropdown.removeClass('active');
      bg.removeClass('active');
      $('.filters__items').removeClass('active');
    }
  });
}

toggleFilters();

function searchSidebarArea() {
  const slider = document.getElementById('filters__slider');
  const parent = document.querySelector('.filters__area');
  if(!parent) return;
  const filterInputs = parent.querySelectorAll('.filters__cost');
  
  noUiSlider.create(slider, {
    start: [0, 500],
    behaviour: 'tap',
    connect: true,
    step: 1,
    range: {
      'min': 0,
      'max': 500
    },
    format: {
      to: value => value,
      from: value => value
    }
  });
  
  slider.noUiSlider.on('update', (values, handle) => { 
    filterInputs[handle].value = values[handle].toFixed(2); 
  });
  
  filterInputs.forEach((input, indexInput) => { 
    input.addEventListener('change', () => {
      slider.noUiSlider.setHandle(indexInput, input.value);
    })
  });

};
searchSidebarArea();